// AUTO-GENERATED — do not edit manually.
// Run `pnpm sync-versions` or `pnpm build` to regenerate.
//
// PRO_VERSIONS: exact versions of @stackwright-pro/* packages in this workspace.
// OSS_VERSIONS: minimum tested versions of @stackwright/* OSS packages (caret range).

/**
 * Exact versions of every @stackwright-pro/* package currently in the workspace.
 * Used by launch-stackwright-pro and scaffold-hooks to pin deps in scaffolded projects.
 * Updated automatically on every build — never edit this file by hand.
 */
export const PRO_VERSIONS = {
  '@stackwright-pro/auth': '0.2.0-alpha.23',
  '@stackwright-pro/auth-nextjs': '0.3.0-alpha.12',
  '@stackwright-pro/build-scripts-plugins': '0.1.0-alpha.10',
  '@stackwright-pro/cesium': '0.1.0-alpha.2',
  '@stackwright-pro/display-components': '0.2.0-alpha.11',
  '@stackwright-pro/mcp': '0.2.0-alpha.108',
  '@stackwright-pro/openapi': '0.3.0-alpha.37',
  '@stackwright-pro/otters': '1.0.0-alpha.74',
  '@stackwright-pro/pulse': '0.3.0-alpha.35',
  '@stackwright-pro/workflow': '0.1.0-alpha.26',
  '@stackwright-pro/workflow-components': '0.1.0-alpha.28',
} as const satisfies Record<string, string>;

/**
 * Minimum tested versions of @stackwright/* OSS packages.
 * Caret ranges anchored to the last version resolved in pnpm-lock.yaml.
 * Updated automatically on every build.
 */
export const OSS_VERSIONS = {
  '@stackwright/build-scripts': '0.10.0-alpha.1',
  '@stackwright/collections': '^0.1.2',
  '@stackwright/core': '^0.10.1',
  '@stackwright/icons': '^0.5.2',
  '@stackwright/mcp': '^0.5.0',
  '@stackwright/nextjs': '^0.6.0',
  '@stackwright/otters': '^0.2.2',
  '@stackwright/types': '^1.7.0',
  '@stackwright/ui-shadcn': '^0.1.3',
} as const satisfies Record<string, string>;
